import {
    DataTypes,
    DynamicFilterOperations,
    FilterOperations,
} from 'business/definitions';
import { EffectiveRequestFilter } from 'components/ChartContainer/types';

const getDateFromOperation = (
    currentDate: Date,
    maxTimeDimensionFieldValue: number,
    targetFilter: EffectiveRequestFilter | QueryFilterT,
    operation: FilterOperationsT | DynamicFilterOperationsT,
) => {
    const maxDataDate = new Date(maxTimeDimensionFieldValue);
    let targetValue;
    let upperBound;
    switch (operation) {
        case DynamicFilterOperations.current:
            return currentDate;
        case DynamicFilterOperations.last:
            targetValue =
                typeof targetFilter.value == 'number' ? targetFilter.value : 0;
            return targetValue >= 2 ? currentDate : maxDataDate;
        case FilterOperations.between:
            upperBound =
                'values' in targetFilter
                    ? targetFilter.values[1]
                    : targetFilter.value?.split('|')[1];
            if (
                (upperBound &&
                    new Date(upperBound).getTime() > currentDate.getTime()) ||
                !upperBound
            ) {
                return currentDate;
            } else return new Date(upperBound);
        case FilterOperations.lower:
        case FilterOperations.lower_or_equal:
            targetValue =
                targetFilter.value !== null
                    ? targetFilter.value
                    : maxTimeDimensionFieldValue;
            if (new Date(targetValue).getTime() > currentDate.getTime())
                return currentDate;
            else return new Date(targetValue);
        case FilterOperations.greater:
        case FilterOperations.greater_or_equal:
            targetValue =
                targetFilter.value !== null
                    ? targetFilter.value
                    : maxTimeDimensionFieldValue;
            if (new Date(targetValue).getTime() < currentDate.getTime())
                return currentDate;
            break;
        default:
            return maxDataDate;
    }
    return maxDataDate;
};

// This functions aims to extract until what date should data be completed:
// we complete to CURRENT_DATE in the following scenarii for time filter:
// - current
// - last with n>= 2
// - between with currentDate between lower and upper bound
// - lower/lower_or_equal with a date after currentDate
// - after with a date before currentDate
// We complete to upperBound in the following scenarii
// - lower/lower_or_equal with a date before currentDate
// - between with upperBound before currentDate
// OtherWise we complete to the maximum date present in data
export const extractCompletionDateFromTimeFilter = (
    data: ResponseDataT[],
    dimensions: QueryDimensionT[],
    filters: EffectiveRequestFilter[] | QueryFilterT[],
): Date => {
    const timeDimensionField = dimensions.find(
        (d) => 'type' in d && d.type === DataTypes.date,
    )?.field;

    const currentDate = new Date();

    if (!timeDimensionField) return currentDate;

    // max date retrieved from data
    const maxTimeDimensionFieldValue = data.reduce((acc, num) => {
        const targetValue =
            typeof num[timeDimensionField] == 'number'
                ? num[timeDimensionField]
                : currentDate.getTime();
        return Math.max(acc, targetValue);
    }, 0);
    const maxDataDate = new Date(maxTimeDimensionFieldValue);

    const targetFilter = filters?.find((f) => timeDimensionField === f.field);
    if (!targetFilter) return maxDataDate;

    const operation =
        targetFilter && 'operation' in targetFilter
            ? targetFilter.operation
            : targetFilter?.operator;

    return getDateFromOperation(
        currentDate,
        maxTimeDimensionFieldValue,
        targetFilter,
        operation,
    );
};
